import React from "react";
import { Card, Table } from "react-bootstrap";
import PageTracking from "../../auth/PageTracking";
import SuperAdminNav from "./SuperAdminNav";
import { POINTS_CONFIG } from "../../util/points/pointsConfig";

function SuperAdminPointsConfig() {
    return (
        <>
            <PageTracking />
            <SuperAdminNav />
            
            <Card className="mb-3">
                <Card.Header>
                    <b>Points Configuration</b>
                </Card.Header>
                <Card.Body>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Parameter</th>
                                <th>Value</th>
                                <th>Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><code>MAX_CHECKINS_PER_DAY_PER_LOCATION</code></td>
                                <td><strong>{POINTS_CONFIG.MAX_CHECKINS_PER_DAY_PER_LOCATION}</strong></td>
                                <td>Maximum number of check-ins per day per location that count towards points</td>
                            </tr>
                            <tr>
                                <td><code>FIRST_VISIT_POINTS</code></td>
                                <td><strong>{POINTS_CONFIG.FIRST_VISIT_POINTS}</strong></td>
                                <td>Points awarded for the first visit to a unique location</td>
                            </tr>
                            <tr>
                                <td><code>POINTS_PER_HOUR</code></td>
                                <td><strong>{POINTS_CONFIG.POINTS_PER_HOUR}</strong></td>
                                <td>Points awarded per hour for non-first visits</td>
                            </tr>
                            <tr>
                                <td><code>BONUS_POINTS</code></td>
                                <td><strong>{POINTS_CONFIG.BONUS_POINTS}</strong></td>
                                <td>Bonus points awarded for checking into a bonus location</td>
                            </tr>
                            <tr>
                                <td><code>BONUS_POINTS_SPAIN</code></td>
                                <td><strong>{POINTS_CONFIG.BONUS_POINTS_SPAIN}</strong></td>
                                <td>Bonus points awarded for visiting locations in Spain</td>
                            </tr>
                        </tbody>
                    </Table>
                    <Card.Text className="text-muted mt-3">
                        <small>
                            These values are defined in <code>src/components/util/points/pointsConfig.ts</code>
                        </small>
                    </Card.Text>
                </Card.Body>
            </Card>
        </>
    );
}

export default SuperAdminPointsConfig;
